import { Collapse } from '@opten/collapse/initializer';
import { Component } from '@opten/compiler/metadata/component';

import { FilterHelper } from './filter-helper';

declare const mixitup: any;

@Component({ className: 'js-filter' })
export class FilterComponent {
	private filter: FilterHelper;

	private mixer: any;
	private targetSelector = '.js-filter-item';
	private sortSelector = '.js-filter-sort';
	private pageListSelector = '.js-filter-page-list';
	private sortControls: HTMLElement[];
	private pageList: HTMLElement;
	private pagerControls: HTMLElement[];

	constructor(private element: HTMLElement) {
		this.pageList = this.element.querySelector(
			'.js-filter-page-list'
		) as HTMLElement;
		this.sortControls = Array.from(
			this.element.querySelectorAll(this.sortSelector)
		) as HTMLElement[];

		this.filter = new FilterHelper(this.element, {
			onReset: () => {
				this.mixer.filter('all');
			},
			onRemoveFilter: (value, name) => {
				const activeFilter = this.mixer.getFilterGroupSelectors(name);
				this.mixer.setFilterGroupSelectors(
					name,
					activeFilter.filter((o) => o !== value)
				);
				this.mixer.parseFilterGroups();
			},
		});

		let options: any = {
			selectors: {
				target: this.targetSelector,
				control: this.filter.options.filterControlSelector,
			},
			controls: {
				scope: 'local',
				toggleLogic: 'and',
				enable: false,
			},
			multifilter: {
				enable: true,
				parseOn: 'submit', //'change',
			},
			callbacks: {
				onParseFilterGroups: (command) => {
					this.filter.updateTags();
					return command;
				},
				onMixStart: (state, futureState) => {
					this.filter.toggleEmptyState(futureState.totalShow > 0);
				},
				onMixEnd: (state) => {
					this.filter.toggleEmptyState(state.totalShow > 0);
				},
				onMixClick: (state, originalEvent) => {
					if (originalEvent.target.closest(this.filter.options.filterControlSelector).getAttribute('data-filter')) {
						originalEvent.preventDefault();
						setTimeout(() => {
							this.mixer.parseFilterGroups();
						}, 500);
					}
				},
			},
		};
		if (this.pageList) {
			options = this.mergeDeep(options, {
				selectors: {
					pageList: this.pageListSelector,
				},
				classNames: {
					elementPager: 'pager',
				},
				pagination: {
					limit: 10,
					maintainActivePage: false,
					hidePageListIfSinglePage: true,
					generatePageStats: false,
				},
				templates: {
					pagerPrev:
						'<button type="button" class="${classNames}" data-page="prev"><span class="icon icon-chevron-left"></span></button>',
					pagerNext:
						'<button type="button" class="${classNames}" data-page="next"><span class="icon icon-chevron-right"></span></button>',
				},
				callbacks: {
					onMixEnd: (state) => {
						this.initPager();
						this.filter.toggleEmptyState(state.totalShow > 0);
					},
				},
			});
		}
		this.mixer = mixitup(this.element, options);

		if (this.sortControls.length > 0) {
			this.sortControls.forEach((sort) => {
				const collapse = Collapse.getInstance(sort.parentElement);
				sort.addEventListener('click', (e) => {
					e.preventDefault();
					this.mixer.sort(sort.getAttribute('data-sort'));
					if (collapse) {
						collapse.hide();
					}
				});
			});
		}

		const params = new URL(document.location).searchParams;
		if (params) {
			const events = {};
			params.forEach((value, key) => {
				const filter = this.filter.filters.find(
					(o) => (o.name == key && o.value == value)
				);
				const filterLink = this.filter.filters.find(
					(o) =>  (o.tagName != 'checkbox' && o.getAttribute('data-filter') == value)
				) as HTMLElement;
				if (filterLink) {
					const t = events[key];
					if (t) {
						t.push(value);
					} else {
						events[key] = [value];
					}
				}
				if (filter) {
					const t = events[filter.name];
					if (t) {
						t.push(filter.value);
					} else {
						events[filter.name] = [filter.value];
					}
					filter.checked = true;
					const changeEvent = new Event('change', {
						bubbles: false,
						cancelable: true,
					});
					filter.dispatchEvent(changeEvent);
				}
			});
			if (Object.keys(events).length > 0) {
				Object.keys(events).forEach((key) => {
					this.mixer.setFilterGroupSelectors(key, events[key]);
				});
				this.mixer.parseFilterGroups();
			}
		}

		this.initPager();
	}

	private initPager() {
		if (this.pageList) {
			this.pagerControls = Array.from(
				this.pageList.querySelectorAll('.mixitup-pager')
			) as HTMLElement[];
			this.pagerControls.forEach((control) => {
				const dataPage = control.getAttribute('data-page');
				control.addEventListener('click', (e) => {
					this.mixer.paginate(dataPage);
				});
			});
		}
	}

	private mergeDeep(target, ...sources) {
		if (!sources.length) return target;
		const source = sources.shift();

		if (this.isObject(target) && this.isObject(source)) {
			for (const key in source) {
				if (this.isObject(source[key])) {
					if (!target[key]) Object.assign(target, { [key]: {} });
					this.mergeDeep(target[key], source[key]);
				} else {
					Object.assign(target, { [key]: source[key] });
				}
			}
		}

		return this.mergeDeep(target, ...sources);
	}

	private isObject(item) {
		return item && typeof item === 'object' && !Array.isArray(item);
	}
}
